import React from 'react';
import { Loader } from 'semantic-ui-react';
import { PageContainer } from '../../../components/pageContainer/PageContainer';
import { Panel } from '../../../components/panel/Panel';
import styles from '../FeedList.module.scss';

interface FeedLoaderProps {
    // Which label to announce. 'post' is the single-article view.
    variant: 'news' | 'event' | 'post';
    label: string;
    // Rendered above the loader so the page keeps a heading while it waits and
    // does not shift when content arrives.
    heading?: string;
}

// Semantic UI's Loader emits no role and no live region, so a screen reader
// lands on a silent page while the feed resolves. Mirrors the announcement
// pattern in src/components/spinner/Spinner.tsx.
export const FeedLoader: React.FC<FeedLoaderProps> = ({ variant, label, heading }) => (
    <PageContainer>
        <Panel>
            {heading && <h1 className={styles.pageTitle}>{heading}</h1>}
            <div
                className={styles.loaderContainer}
                role="status"
                aria-live="polite"
                data-testid={`feed-loader-${variant}`}
            >
                <Loader active inline="centered">
                    {label}
                </Loader>
            </div>
        </Panel>
    </PageContainer>
);
